export default function (el) {
  const html = el.textContent.trim();
  const chars = html.split('');
  // eslint-disable-next-line no-param-reassign
  el.innerHTML = '';
  chars.forEach((char) => {
    const span = document.createElement('span');
    span.setAttribute('data-char', char);
    span.textContent = char;
    el.appendChild(span);
  });
}
